/**
 * Tweaks v2 — client barrel. `store.ts` is server-only (node:fs) and is
 * imported directly by the `/dev/tweaks/context-state` route, never from
 * here.
 */

export { TweaksProvider } from "./provider";
export type { TweaksProviderValue } from "./provider";
export { useTweaks } from "./useTweaks";
export type {
  TweakControlValueReader,
  TweakMarkRefRegistrar,
  UseTweaksResult,
} from "./useTweaks";
export {
  TweaksBeacon,
  TweaksBeaconMessageType,
  TWEAKS_BEACON_CHANNEL_NAME,
} from "./beacon";
export type {
  TweaksBeaconContextUpdatedMessage,
  TweaksBeaconHandler,
  TweaksBeaconLocateMessage,
  TweaksBeaconMessage,
  TweaksBeaconPresenceContext,
  TweaksBeaconPresenceMark,
  TweaksBeaconPresenceMessage,
  TweaksBeaconPresenceRequestMessage,
  TweaksBeaconRevealDescriptor,
} from "./beacon";
export {
  collectRegistrationMarkProblems,
  normalizeTweaksSpec,
  registrationEntryLeafNames,
  registrationLeafNames,
  RESERVED_TWEAKS_RESULT_KEYS,
  storedMarkLeafOptions,
  storedTreeLeafOptions,
  TWEAKS_COLLECTION_SLUG_PATTERN,
  TWEAKS_CONTEXT_NAME_PATTERN,
  TWEAKS_DEFAULT_MIN_VARIANTS,
  TWEAKS_IMAGES_REPO_RELATIVE_DIR,
  TWEAKS_SCHEMA_VERSION,
  TweakControlKind,
  TweakConversationAuthor,
  TweakItemState,
  TweakOptionNodeKind,
  TweakOptionSentinel,
  TweakRequestKind,
  TweakRequestStatus,
  TweakSaveTarget,
  TweaksStoreOp,
} from "./types";
export type {
  NormalizedTweaksSpec,
  TweakCollectionFile,
  TweakCollectionItem,
  TweakCommentText,
  TweakComposedRequestKind,
  TweakContextFile,
  TweakControl,
  TweakControlValue,
  TweakConversationEntry,
  TweakIssueRequest,
  TweakMark,
  TweakMarkReveal,
  TweakOption,
  TweakOptionGroupNode,
  TweakOptionLeafNode,
  TweakOptionNode,
  TweakRequest,
  TweakRequestInput,
  TweakSaveProvenance,
  TweakSaveRequest,
  TweakSliderControl,
  TweakToggleControl,
  TweakVariantsRequest,
  TweaksAddRequestOpPayload,
  TweaksAddSaveRequestOpPayload,
  TweaksCollectionAddRequestOpPayload,
  TweaksDeleteRequestOpPayload,
  TweaksDisputeOpPayload,
  TweaksEditRequestOpPayload,
  TweaksMarkSeenOpPayload,
  TweaksMarkSpec,
  TweaksMarkSpecEntry,
  TweaksRegistrationEntry,
  TweaksRegistrationGroup,
  TweaksRegistrationMark,
  TweaksRegistrationOption,
  TweaksRevealSpec,
  TweaksSetControlCommentOpPayload,
  TweaksSetControlLockedOpPayload,
  TweaksSetControlValueOpPayload,
  TweaksSetDecisionOpPayload,
  TweaksSetMarkRemovalOpPayload,
  TweaksSetOptionRemovalOpPayload,
  TweaksSetRequestStatusOpPayload,
  TweaksSetSelectionOpPayload,
  TweaksSpec,
} from "./types";

/** Dev-page index shapes. The module itself is server-only (node:fs); the page
 *  reads the index through the store seam, so only its types travel here. */
export { DevPageRequestKindOptions } from "./types";
export type {
  DevPageEntryState,
  DevPageAnnotationState,
  DevPageRequestState,
} from "./dev-pages";
